export default __webpack_public_path__ + "static/media/bdu.c1d5203a.png";